<template>
  <div>
    <LateralBar />

    <div class="content">
      <AddZipcode />
    </div>
  </div>
</template>

<script>
import LateralBar from "../components/LateralBar";
import AddZipcode from "../components/AddZipcode";

export default {
  components: {
    LateralBar,
    AddZipcode,
  },
};
</script>

<style scoped>
.content {
  padding: 110px 20px 20px 130px;
}
</style>
